import React, {
  useRef,
  useState,
  useEffect,
  forwardRef,
  useImperativeHandle,
  useCallback,
} from "react";
import SearchPanel from "@widgets/SearchPanel"; // 조회조건 Panel
import { fnGetDataSet, fnSave } from "@shared/api/restApi"; // BackEnd API
import {
  getInitFormData,
  getNoSlip,
  getTablebySql,
} from "@shared/utils/CommonUtils"; // 공통 유틸 메뉴 초기화(조회조건, 그리드, 프리폼) 설정 load 관련 내용
import { showDialog } from "@widgets/CommonDialog"; // Message Box
import { global, globalMenu, useMenuStore } from "@shared/libs/Global"; // Login User관련 전역 변수( 로그인 정보)
import SnGrid from "@shared/components/Grid/SnGrid"; // 공통 그리드
import { menuInfo } from "@shared/type/CommonType"; // 공통 Interface
import SnButton from "@shared/components/SnButton";
import { ProcessCellForExportParams } from "ag-grid-community";
import usePanelSizes from "@shared/hooks/usePanelSizes";
import SnResizable from "@shared/components/SnResizable";
import SnTree from "@shared/components/Grid/SnTree";
import SharedForm from "@widgets/SharedForm";
import SnTabHeader from "@shared/components/SnTabHeader";
import CommonSpinner from "@widgets/CommonSpinner";

interface Props {
  Menuprops: menuInfo;
}

interface RowData {
  KeyField?: string; // 행의 고유 ID
  [key: string]: any;
}

const SN_SYS_BAS_REG_004 = forwardRef(({ Menuprops }: Props, ref) => {
  //#region  variable
  const searchRef = useRef<any>(null);
  const today = new Date();
  const todayform = `${today.getFullYear()}${(today.getMonth() + 1)
    .toString()
    .padStart(2, "0")}${today.getDate().toString().padStart(2, "0")}`;
  const popDate = new Date();
  popDate.setDate(1);
  const firstDayOfMonth = `${popDate.getFullYear()}${(popDate.getMonth() + 1)
    .toString()
    .padStart(2, "0")}${popDate.getDate().toString().padStart(2, "0")}`;

  const { userInfo } = global(); // Login user 정보
  const { menuItems } = useMenuStore();

  //#region  Components useState
  const [formData, setFormData] = useState<any>(); // 조회조건 변수
  const [formControlData, setFormControlData] = useState<any[]>([]); // 조회조건 설정된 항목 bindin
  const [treeDataSource, setTreeDataSource] = useState<any>();
  const treeGridApiRef = useRef<any>(null);
  const [sharedForm, setSharedForm] = useState<any[]>([]);
  const SharedFormref1 = useRef<any>();

  const [dataSource1, setDataSource1] = useState<any[]>([]); // gridApiRefH datasource 관련
  const [dataSource2, setDataSource2] = useState<any>(); // gridApiRefL datasource 관련

  const [gridFocus, setGridFocus] = useState(false);
  //#endregion
  const [focusedRowData, setFocusedRowData] = useState<any>();
  const [columns, setColums] = useState<any[]>([]);
  const cd_menu = Menuprops.cd_menu || "SN_SYS_BAS_REG_004";
  const defaultSize = { panel1height: "49.5%", panel2height: "49.5%" };
  const [sizes, onResizeStop] = usePanelSizes(cd_menu, defaultSize);
  const [loading, setLoading] = useState<boolean>(false);
  const [btnText, setbtnText] = useState<string>("COLLAPSE");

  //#endregion

  useEffect(() => {
    const fetchform = async () => {
      setDataSource1([]);
      setDataSource2([]);
      try {
        const rtn: any = await getInitFormData();

        setFormControlData(rtn.formControlData); // 조회조건 항목 설정

        setFormData(rtn.formData);
        setColums(rtn.grid.tree1);
        setSharedForm(rtn.form.freeform1);
        // await new Promise((resolve) => setTimeout(resolve, 0));
        // setLoading(true);
        // await onSearch();
        // setLoading(false);
      } catch (error) {}
    };
    fetchform();
  }, []);

  useEffect(() => {
    if (!formData) return; // formData가 아직 없으면 실행 안 함

    const doSearch = async () => {
      setLoading(true);
      try {
        await onSearch();
      } finally {
        setLoading(false);
      }
    };

    doSearch();
  }, [formData]);

  useEffect(() => {
    treeGridApiRef.current.selectAndFocusRow(0);
    setGridFocus(false);
  }, [gridFocus]);

  //#region  Button Event
  useImperativeHandle(ref, () => ({
    onSearch,
    onInsert,
    onDelete,
    onSave,
  }));
  //#region  OnSearch
  const onSearch = async () => {
    const modifiedRowsH = treeGridApiRef.current.getChange();

    if (modifiedRowsH.modifiedRowcount > 0) {
      const confirm = await showDialog(
        "confirm",
        "수정된 내용이 있습니다. 저장하시겠습니까?"
      );
      if (confirm) {
        const checkSave: any = await onSave();
        if (!checkSave) {
          return;
        }
      }
    }
    const searchForm = searchRef.current?.getFormdata?.() ?? {};
    try {
      const params = {
        id: "sn_sys_bas_reg_004_01",
        params: {
          cd_module: searchForm.cd_module ?? "",
          search: searchForm.search ?? "",
        },
      };

      setTreeDataSource([]);
      const data: any = await fnGetDataSet(params);

      // setTreeDataSource(data[0]);

      const transformedData = (() => {
        // `cd_group`를 키로, 항목을 값으로 하는 Map 생성
        const groupMap = new Map(
          data[0].map((item: any) => [item.cd_menu, item])
        );

        return data[0].map((item: any) => {
          const path_arr = [];
          let currentItem = item;

          while (currentItem) {
            path_arr.unshift(currentItem.cd_menu);
            currentItem = groupMap.get(currentItem.cd_menu_parent);
          }
          return { path_arr, ...item };
        });
      })();

      setTreeDataSource(transformedData);

      if (data[0] && data[0].length > 0) {
        // 1. 그리드 데이터가 바인딩되었음을 기다림
        await new Promise((resolve) => setTimeout(resolve, 50)); // 비동기 반영 대기 (최적화 가능)

        // 2. 첫 번째 행 선택 및 포커스 설정
        setGridFocus(true);
      }
      treeGridApiRef.current.api.expandAll();
      setbtnText("COLLAPSE");

      await new Promise((resolve) => setTimeout(resolve, 0));

      const firstRowNode = treeGridApiRef.current.api.getDisplayedRowAtIndex(0);
      if (firstRowNode) {
        firstRowNode.setSelected(true);
        treeGridApiRef.current.api.setFocusedCell(0, "nm_group");
        setFocusedRowData(firstRowNode.data);
      }
      treeGridApiRef.current.resetUpdate();
    } catch (error: any) {
      showDialog("error", error.message);
    }
  };
  //#region OnInsert
  const onInsert = async () => {
    const selectedRows = treeGridApiRef.current.api.getSelectedNodes();

    let topLevelParents = 0;

    treeGridApiRef.current?.api?.forEachNode((node: any) => {
      if (node.level === 0 && node.childrenAfterGroup?.length > 0) {
        topLevelParents++;
      }
    });
    const uniqueId = Date.now() + Math.floor(Math.random() * 1000);
    const noSeq = topLevelParents + 1;
    try {
      const newRow = {
        cd_user_reg: userInfo.cd_user,
        cd_menu_parent: "",
        nm_menu_parent: "",
        cd_menu: "",
        nm_menu: "",
        nm_menu_origin: "",
        nm_emenu: "",
        nm_cnmenu: "",
        nm_jpmenu: "",
        nm_vnmenu: "",
        cd_module: "",
        fg_menu: "MGM",
        no_mgmt: "",
        no_level: 1,
        no_seq: noSeq,
        no_pos: "001" + noSeq.toString().padStart(3, "0"),
        nm_window: "",
        nm_file: "",
        nm_window_net: "",
        nm_file_net: "",
        nm_emp_design_origin: "",
        nm_emp_design: "",
        nm_emp_dev_origin: "",
        nm_emp_dev: "",
        nm_emp_dev_origin2: "",
        nm_emp_dev2: "",
        yn_exc: "N",
        nm_cust_exc: "",
        path_arr: [...[], `temp-${uniqueId}`],
      }; // 빈 객체
      treeGridApiRef.current?.addRow(newRow);
      await new Promise((resolve) => setTimeout(resolve, 0));

      //to make sure focused is on the inserted row
      const lastRowIndex =
        treeGridApiRef.current.api.getDisplayedRowCount() - 1;

      treeGridApiRef.current.api.ensureIndexVisible(lastRowIndex, "middle");

      const rowNode =
        treeGridApiRef.current.api.getDisplayedRowAtIndex(lastRowIndex);
      rowNode.setSelected(true);
      treeGridApiRef.current.api.setFocusedCell(lastRowIndex, "nm_group");
    } catch (error: any) {}
  };
  //#region OnDelete
  const onDelete = async () => {
    const gridApiH = treeGridApiRef.current.api;
    const rowCount = gridApiH.getDisplayedRowCount();
    if (rowCount === 0) {
      return;
    }
    const confirm = await showDialog("confirm", "삭제하시겠습니까?");

    if (!confirm) {
      return; // 사용자가 아니오를 선택하면 함수 종료
    }

    treeGridApiRef.current?.deleteSelectedRows();

    const realDeletedRows = treeGridApiRef.current.getChange().delete ?? [];
    if (Array.isArray(realDeletedRows) && realDeletedRows.length < 1) {
      // 실제로 삭제된 행이 없으면 변경 사항을 적용하고 반환합니다.
      treeGridApiRef.current.resetUpdate();
      return;
    }

    return await onSave();
  };
  //#region onAddRow
  const onAddRow = async () => {
    try {
      const selectedRows = treeGridApiRef.current.api.getSelectedNodes();
      if (!selectedRows || selectedRows.length === 0) {
        showDialog("alter", "추가할 위치를 선택해 주세요.");
        return;
      }
      const parentFgMenu = selectedRows[0].data?.fg_menu;

      if (parentFgMenu !== "MGM") {
        showDialog("alter", "메뉴 구분을 확인해 주세요.");
        return;
      }
      const rowChanges = treeGridApiRef.current.getChange().insert;
      const allRowData: any[] = [];
      treeGridApiRef.current.api.forEachNode((node: any) => {
        allRowData.push(node.data);
      });

      const selectedNode = selectedRows[0];
      const selectedNodeChildren = selectedNode.childrenAfterGroup || [];
      const maxNoLine =
        selectedNodeChildren.length > 0
          ? Math.max(
              ...selectedNodeChildren.map(
                (child: any) => child.data.no_line || 0
              )
            )
          : 0;
      //if (rowChanges.length > 0) return false;
      if (!selectedNode.expanded) {
        selectedNode.setExpanded(true); // 선택한 노드 확장
        selectedNode.group = true;
        treeGridApiRef.current.api.onGroupExpandedOrCollapsed(); // 확장 상태를 반영
      }
      const seq = selectedNodeChildren.length + 1;

      const newRow = {
        cd_user_reg: userInfo.cd_user,
        cd_menu_parent: selectedNode.data?.cd_menu,
        nm_menu_parent: selectedNode.data?.nm_menu,
        cd_menu: "",
        nm_menu: "",
        nm_menu_origin: "",
        nm_emenu: "",
        nm_cnmenu: "",
        nm_jpmenu: "",
        nm_vnmenu: "",
        cd_module: selectedNode.data?.cd_module,
        fg_menu: "MGM",
        no_mgmt: "",
        no_level: Number(selectedNode.data?.no_level) + 1,
        no_seq: seq,
        no_pos:
          selectedNode.data?.no_pos.toString() +
          seq.toString().padStart(3, "0"),
        nm_window: "",
        nm_file: "",
        nm_window_net: "",
        nm_file_net: "",
        nm_emp_design_origin: "",
        nm_emp_design: "",
        nm_emp_dev_origin: "",
        nm_emp_dev: "",
        nm_emp_dev_origin2: "",
        nm_emp_dev2: "",
        yn_exc: "N",
        nm_cust_exc: "",
        // path_arr: [...(selectedRows[0].data?.path_arr || []), `temp`],
        path_arr: [
          ...(selectedRows[0].data?.path_arr || []), // 부모의 path_arr를 복사
          `temp-${seq + 1}`, // 새로운 child 값을 추가
        ],
      };

      treeGridApiRef.current?.addRow(newRow);
    } catch (error: any) {}
  };

  //#region OnDeleteRow
  const onDeleteRow = async () => {
    if (treeGridApiRef.current?.api?.getDisplayedRowCount() < 1) {
      return;
    }
    treeGridApiRef.current?.deleteSelectedRows();
  };
  //#region onSave
  const onSave = async () => {
    try {
      const requiredValuesCheckL = treeGridApiRef.current.requiredValuesCheck();
      if (!requiredValuesCheckL) return;

      const changesRow = treeGridApiRef.current.getChange();
      const allRows = [
        ...(changesRow.insert ?? []),
        ...(changesRow.update ?? []),
      ];

      const requiredFields: { [key: string]: string } = {
        cd_menu: "메뉴코드는 필수값입니다.",
        nm_menu_origin: "원메뉴명은 필수값입니다.",
        nm_menu: "메뉴명은 필수값입니다.",
        cd_module: "모듈명은 필수값입니다.",
        fg_menu: "메뉴구분은 필수값입니다.",
        no_level: "메뉴레벨은 필수값입니다.",
        no_seq: "메뉴순서는 필수값입니다.",
        yn_exc: "전용여부는 필수값입니다.",
      };

      for (let i = 0; i < allRows.length; i++) {
        const row = allRows[i];
        for (const [key, message] of Object.entries(requiredFields)) {
          if (
            row[key] === undefined ||
            row[key] === null ||
            String(row[key]).trim() === ""
          ) {
            await showDialog("alter", `${message}`);
            return;
          }
        }
      }

      if ((changesRow.modifiedRowcount || 0) === 0) {
        await showDialog("alert", "변경된 내용이 없습니다.");
        return;
      }

      const SaveData = {
        sys_notesmenu: changesRow,
      };
      if (changesRow.modifiedRowcount === 0) {
        await showDialog("alter", "변경된 내용이 없습니다.");
        return;
      }
      await fnSave("SN_SYS_BAS_REG_004_SAVE_01", SaveData);

      treeGridApiRef.current.resetUpdate();

      return true;
    } catch (error: any) {}
  };

  //region onFocusedRowChanged
  const onFocusedRowChanged = useCallback(
    (focusedRowData: any | null) => {
      setFocusedRowData(focusedRowData);
    },
    [focusedRowData]
  );
  //#region autoGroup
  const autoGroupColumnDef = {
    field: "nm_menu",
    flex: 1,
    filter: "agTextColumnFilter",
    cellClass: "large-cell",
    editable: false,
    cellRendererParams: {
      suppressCount: true,
      suppressDoubleClickExpand: true,
      suppressHoverHighlight: false,
      innerRenderer: (params: any) => {
        const { value, node } = params;

        let icon = "";
        if (node.data.fg_menu === "MGM" || node.data.fg_menu === "") {
          icon = node.expanded ? "📂" : "📁";
        } else if (node.data.fg_menu === "REG") {
          icon = "📝";
        } else if (node.data.fg_menu === "REP") {
          icon = "📄";
        }

        return `${icon} ${value}`;
      },
    },
    cellRenderer: "agGroupCellRenderer",
  };

  const onGrid1BtnsClick = async (id: string) => {
    if (!treeDataSource) return;
    if (id === "btnCollapse") {
      if (btnText === "COLLAPSE") {
        setbtnText("EXPAND");
        treeGridApiRef.current.api.collapseAll();
      } else {
        setbtnText("COLLAPSE");
        treeGridApiRef.current.api.expandAll();
      }
    }
    if (id == "addRow") {
      onAddRow();
    }
    if (id == "deleteRow") {
      onDeleteRow();
    }
  };
  //#region onValueChanged
  const onValueChaged = async (data: any, param: string, formData: any) => {
    switch (param) {
      case "nm_menu_origin":
        if (formData.nm_menu === "") {
          return { nm_menu: data };
        }
        break;
      case "nm_emp_design_origin":
        if (!formData.nm_emp_design) {
          return { nm_emp_design: data };
        }
        break;
      case "nm_emp_dev_origin":
        if (!formData.nm_emp_dev) {
          return { nm_emp_dev: data };
        }
        break;

      case "yn_exc":
        if (data === "Y") {
          const update = sharedForm.map((row: any) =>
            row.cd_param === "nm_cust_exc" ? { ...row, dc_editcon: null } : row
          );

          setSharedForm(update);
        } else {
          const update = sharedForm.map((row: any) =>
            row.cd_param === "nm_cust_exc"
              ? { ...row, dc_editcon: "true" }
              : row
          );

          setSharedForm(update);
        }
        break;

      default:
        return {};
    }
  };

  //#region  UI
  return (
    <div className="h-full flex flex-col">
      <div className="mb-1">
        <SearchPanel
          ref={searchRef}
          data={formData}
          controls={formControlData}
          
        />
      </div>

      <div className="w-full h-full flex space-x-2">
        <CommonSpinner isLoading={loading} />
        <SnResizable
          direction={"width"}
          seq={1}
          cd_menu={cd_menu}
          defaultSize={defaultSize}
          size={sizes.panel1height}
          onResizeStop={onResizeStop}
          enable={{ right: true }}
          minHeight={130}
        >
          <SnTree
            
            ref={treeGridApiRef}
            columnConfig={columns}
            animateRows={false}
            rowData={treeDataSource}
            isEditable={true}
            suppressNoRowsOverlay={true}
            onFocusedRowChanged={onFocusedRowChanged}
            rowSelection="single"
            title="메뉴"
            getDataPath={(data) => data.path_arr}
            autoGroupColumnDef={autoGroupColumnDef}
            headerHeight={0}
            onBtnAddClick={onGrid1BtnsClick}
            onBtnDeleteClick={onGrid1BtnsClick}
            header={
              <div style={{ paddingRight: 20 }}>
                <SnButton
                  text={btnText}
                  onClick={() => {
                    onGrid1BtnsClick("btnCollapse");
                  }}
                />
              </div>
            }
          />
        </SnResizable>
        <SnResizable
          direction={"width"}
          seq={2}
          cd_menu={cd_menu}
          defaultSize={defaultSize}
          size={sizes.panel2height}
          onResizeStop={onResizeStop}
          enable={{ right: true }}
          minHeight={130}
        >
          <SharedForm
            ref={SharedFormref1}
            data={focusedRowData}
            controls={sharedForm}
            gridref={treeGridApiRef}
            title="상세내용"
            
            onValueChaged={onValueChaged}
          />
        </SnResizable>
      </div>
    </div>
  );
  //#endregion
});

export default SN_SYS_BAS_REG_004;
